<template>
  <v-main class="page-suitcase page-suitcase-myInfo">
    <AppBar/>
    <v-layout fill-height column>

      <div class="d-flex justify-center py-5">
          <div class="pos-relative" style="width: 88px; height:88px ;">
            <v-img :src="profile" height="88" width="88" class="rounded-circle"></v-img>
            <v-btn plain icon :ripple="false" class="pos-absolute bottom-n2 right-n2">
              <img :src="getImage('ic_camera.svg')" @click="onImageClick">
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept="image/*"
                @change="upload"
              >
            </v-btn>
          </div>
      </div>

      <v-container class="container-my-info" fluid>
        <div class="my-info-title-block">
          <h2 class="tit">회원 정보</h2>
          <v-spacer />
          <!-- 기업회원시 노출 -->
          <v-chip small color="black" dark v-if="memberGb === '01'">기업회원</v-chip>
          <!-- //기업회원시 노출 -->
        </div>
        <dl class="my-info-row">
          <dt>아이디</dt>
          <dd class="d-flex">
            <!-- 소셜 로그인 뱃지 추가 -->
            <v-img v-if="memberInfo.joinKind === '02'" :src="snsBadge" max-width="30px" class="my-2 me-2" />
            <div class="flex-grow-1">{{ memberInfo.userId }}</div>
          </dd>

          <dt>이름</dt>
          <dd>{{ memberInfo.userName }}</dd>

          <dt class="label">생년월일</dt>
          <dd>{{ Util.Date.toDate(memberInfo.birthyyMmday) }}</dd>

          <dt>성별</dt>
          <dd>{{ memberInfo.genderNm }}</dd>

          <dt>이메일</dt>
          <dd>{{ memberInfo.email }}</dd>

          <dt>비밀번호</dt>
          <dd>
            ********
            <v-btn :ripple="false" depressed small rounded
                   width="80"
                   color="primary"
                   class="btn-input"
                   @click="goToPasswdChange">
              변경하기
            </v-btn>
          </dd>

          <dt>휴대전화</dt>
          <dd>
            {{ Util.Common.replacePhoneNumber(memberInfo.mobileNo) }}
            <v-spacer/>
            <v-btn :ripple="false" depressed small rounded
                   width="80"
                   color="primary"
                   class="btn-input"
                   @click="goToChangeCallNumber">변경하기
            </v-btn>
          </dd>

          <dt>닉네임</dt>
          <dd>
            {{ nickname }}
            <v-btn :ripple="false" depressed small rounded
                   width="80"
                   color="primary"
                   class="btn-input"
                   @click="next('/fo/nickname')">변경하기
            </v-btn>
          </dd>
        </dl>
      </v-container>

      <v-container fluid class="container-my-info" v-if="memberGb==='01'">
        <div class="my-info-title-block">
          <h2 class="tit">소속회사 정보</h2>
          <v-spacer/>
          <v-btn :ripple="false" depressed small rounded
                 width="80"
                 color="primary"
                 class="btn-input"
                 @click="goToAgencyCompanyInfo">변경하기
          </v-btn>
        </div>
        <dl class="my-info-row">

          <dt>회사명</dt>
          <dd>{{ memberInfo.clientNm }}</dd>

          <dt>직무</dt>
          <dd> {{ memberInfo.jobName }}</dd>

          <dt>직급</dt>
          <dd>{{ memberInfo.pstName }}</dd>

          <dt>부서</dt>
          <dd>{{ memberInfo.depart }}</dd>

        </dl>
      </v-container>


		<v-container fluid class="container-my-info">
			<div class="my-info-title-block">
				<h2 class="tit">부가정보</h2>
				<v-spacer/>
			</div>
			<dl class="my-info-row">
				<dt>광고성 수신동의</dt>
			</dl>
		</v-container>
		<v-container flex-fill fluid class="pt-0">
		<ul class="list">
			<li>
				<div class="fs-15 fw-500">SMS/MMS 수신동의</div>
				<v-switch
					v-model="smsRecvYn"
					inset
					:ripple="false"
					class="switch"
					hide-details="false"
					value="Y"
					@change="setAdvertInfoRecvYn('sms')"
				></v-switch>
			</li>
			<li>
				<div class="fs-15 fw-500">이메일 수신동의</div>
				<v-switch
					v-model="emailRecvYn"
					inset
					:ripple="false"
					class="switch"
					hide-details="false"
					value="Y"
					@change="setAdvertInfoRecvYn('email')"
				></v-switch>
			</li>
		</ul>
		</v-container>
      <v-snackbar v-model="snackbar" :timeout="timeout" absolute top elevation="0">
        변경이 완료되었습니다.
      </v-snackbar>
    </v-layout>
  </v-main>
</template>
<script>
import store from "@/store";
import {mixinRemote, mixinAuth, mixinReward} from '@/mixins'
import utils from '../../utils/utils.js'
import moment from "moment";
import Util from "../../utils/utils.js";
moment.locale("ko");

export default {
  mixins: [mixinRemote, mixinAuth, mixinReward],
  data: () => ({
    // profile: '',
    mindWeather: null,
    mindWeatherArr: ['마음 날씨', '몸 날씨', '기분 날씨'],
    snackbar: false,
    timeout: 3000,

    mktRecvApplyYn: '',
    smsRecvYn:'',
    emailRecvYn:'',

    file: '',
    fileId: '',
    beforeFileId: '',

    fileName: '',
    beforeFileName: '',

    enableList:[],
    deleteList:[],
  }),
  computed: {
    Util() {
      return Util
    },
    profile() {
      // 삼성화재는 들어올일이 닉네임변경으로 가기때문에 접근할일 없겠지만 일단 분기
      let avatar = null
      if(store.getters.profileAtchNo == null || store.getters.profileAtchNo < 1){

        if(this.isSamsungFire){
          avatar = this.avatarImages.filter(a => a.key === store.getters.profileAtchNo)
          if (avatar.length) return avatar[0].url
          else return this.avatarImages[0].url

        } else{

          return require('@/assets/images/bi/bi_img.png')
        }
      } else{

        // if (this.isSamsungFire) {

        //   avatar = this.avatarImages.filter(a => a.key === store.getters.profileAtchNo)
        //   if (avatar.length) return avatar[0].url
        //   else return this.avatarImages[0].url

        // }else{
          avatar = store.getters.profileAtchFileName
          // this.beforeFileId = store.getters.profileAtchNo  //기존 파일 아이디

          return this.$downUrl(avatar)
        // }
      }
    },
    snsBadge () {
      let provider = this.memberInfo.provider
      if (provider === 'kakao') {
        return require('@/assets/images/ic_kakao.svg')
      } else if (provider === 'naver') {
        return require('@/assets/images/ic_narver.svg')
      }
      return null
    }
  },
  created() {
    this.beforeFileId = store.getters.profileAtchNo
    this.beforeFileName = store.getters.profileAtchFileName
    this.snackbar = this.$route.params.snackbar;
    this.smsRecvYn = this.memberInfo.smsRecvYn
    this.emailRecvYn = this.memberInfo.emailRecvYn
  },
  mounted() {},
  methods: {
    async setAdvertInfoRecvYn (param) {
      let params = {
        mktRecvApplyYn: this.smsRecvYn === 'Y' || this.emailRecvYn === 'Y' ? 'Y' : 'N',
        smsRecvYn: this.smsRecvYn === 'Y' ? this.smsRecvYn : 'N',
        emailRecvYn: this.emailRecvYn === 'Y' ? this.emailRecvYn : 'N'
      }
      await store.dispatch('setAdvertInfoRecvYn', this.$_payload('inData',params))
        .then(res => {
          if (res.success) {
            let agree = (param === 'sms') ? (this.smsRecvYn === 'Y') : (this.emailRecvYn === 'Y')
            let msg = '광고성 ' + (param === 'sms' ? 'SMS/MMS' : '이메일') + ' 수신여부가<br/>'
                + (agree ? '동의' : '동의안함') + ' 처리 되었습니다.<br/>'
                + moment().format('YYYY-MM-DD')
            store.commit('setMemberInfo', params)
            this.$alert(msg)
          } else {
            console.log(res.msg);
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {})
    },

    //기업회원 소속정보 변경.
    goToAgencyCompanyInfo() {
      this.$router.push({name: "소속회사정보설정"});
    },
    goToChangeCallNumber() {
      this.$router.push({name: "휴대전화변경"});
    },
    goToPasswdChange() {
      this.$router.push({name: "비밀번호변경"});
    }
    , next(link) {
      this.$router.push(link);
    },
    onImageClick(){
      this.$refs.uploader.click()
    },
    async upload(e) {

      // 삭제 대상에 넣기
      if(this.beforeFileId != null && this.beforeFileId != '' && this.beforeFileId > 0){
        this.deleteList.splice(0, this.deleteList.length)
        this.deleteList.push(this.fileId)
      }

      this.file = e.target.files[0];
      var formData = new FormData();
      formData.append('file', this.file);
      formData.append('beforeFileId', this.beforeFileId);

      utils.File.fileUpload(formData
      ).then(response => {

        if(response.success){

          this.fileId = response.data.fileId
          this.beforeFileId = response.data.fileId
          // TODO fileId 뺴기
          this.beforeFileName = response.data.fileName
          this.fileName = response.data.fileName

          // enable 대상에 추가
          this.enableList.splice(0, this.enableList.length)
          this.enableList.push(this.fileId)
          this.fileEnable()
        }else{
          this.$alert('사진 업로드에 실패하였습니다.')
        }
      })
      .catch(async error => {
        console.log(error)
        this.$alert('사진 업로드에 실패하였습니다.')
      })
    },
    async fileEnable() {
      utils.File.fileEnable(this.enableList
        ).then(response => {
          if(response.data){
            // 회원정보 profileAtchNo 수정
            this.putProfileAtchNo()

          }else{
            this.$alert('사진 업로드 승인에 실패하였습니다.')
          }
        })
        .catch(async error => {
          console.log(error)
          this.$alert('사진 업로드 승인에 실패하였습니다.')
        })
    },
    async putProfileAtchNo() {
      // await store.dispatch('setLibraryLike', this.$_payload({'libNo': this.libNo}, {}))
      await store.dispatch('putProfileAtchNo', this.$_payload({'profileAtchFileName': this.fileName}, {}))
          .then(res => {
            if (res.success) {

              // auth에 profileAtchNo 최신화
              store.commit('setProfileAtchNo', this.fileId)
              store.commit('setProfileAtchFileName', this.fileName)

              // 삭제 대상 존재시 삭제
              if (this.deleteList.length > 0) {
                this.fileDelete()
              }

              // 프로필 이미지 변경 코인획득 1회
              this.insertMemberCoin(this.userKey, 1, '0010')
              // this.$root.$children[0].$refs.content.$emit('insertMemberCoin', this.$store.state.auth.authUser.userKey, 1, '0010')

              // 세션 업데이트
              this.sessionUpdateProfileAtchNo(this.fileId)

            } else {
              this.$alert('회원정보 수정에 실패하였습니다.')
            }
          })
          .catch(error => {
            console.error(error)
            this.$alert('회원정보 수정에 실패하였습니다.')
          })
          .finally(() => {
          })
    },
    async fileDelete() {
      utils.File.fileDelete(this.deleteList
        ).then(() => {
          // console.log("삭제 : ", response.data)
        })
        .catch(async error => {
          console.log(error)
        })
    },
    async sessionUpdateProfileAtchNo(fileId) {
      await store.dispatch('updateProfileAtchNo', this.$_payload(null, {profileAtchNo: fileId, profileAtchFileName: this.fileName}))
        .then(async res => {
          if (res.success) {
            // console.log("session set success")
          } else {
            console.log(res.msg)
          }
        })
        .catch(async error => {
          console.log(error)
        })
        .finally(() => {
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.list {
    li {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #E6E8EA;
        padding: 20px 0;
        &:first-child {
            border-top: none;
        }
    }
}
.v-input--selection-controls::v-deep {
    margin-top: 0;
    padding-top: 0;
    .v-input--selection-controls__input {
        margin-right: 0;
        width: 42px;
    }
}
</style>
